module.exports = __webpack_public_path__ + "static/ka_zu53-c8677178c5331c1cde4228872620d9a8.jpg";